// 爱奇艺
const aqyRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `see/aqy/index${i + 1}`,
  name: `see/aqy/Index${i + 1}`,
  component: () => import(`@/views/entertainment/see/aqy/index${i + 1}.vue`)
}))
// 腾讯视频
const txRoutes = Array.from({ length: 15}, (_, i) => ({
  path: `see/tx/index${i + 1}`,
  name: `see/tx/Index${i + 1}`,
  component: () => import(`@/views/entertainment/see/tx/index${i + 1}.vue`)
}))


import seeIndex from '@/views/entertainment/see/index'



export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'see/index',
        name: 'seeIndex',
        component: seeIndex
      },

    ...aqyRoutes,
    ...txRoutes,


  ],
};
